import CardIcon from './card.svg';
import CashIcon from './cash.svg';
import MfoIcon from './mfo.svg';
import RefinanceIcon from './refinance.svg';

export const productTypeIcons = {
  cash: CashIcon,
  creditCard: CardIcon,
  microCredit: MfoIcon,
  refinance: RefinanceIcon,
};
